import { render } from "./oap-beauty-award.vue?vue&type=template&id=1b43e0a7"
import script from "./oap-beauty-award.vue?vue&type=script&lang=js"
export * from "./oap-beauty-award.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__